// extracted by mini-css-extract-plugin
export var closeButton = "_li-1";
export var closeX = "_li-3";
export var container = "_li-0";
export var image = "_li-2";